import {
  REQUEST_CHANGE_TIME_LOGISTIC_REPORT,
  READY_CHANGE_TIME_LOGISTIC_REPORT,
  RESET_TIME_LOGISTIC_REPORT,
  CHANGE_SEARCH_TERM_LOGISIC_REPORT,
  REQUEST_CP_REPORTS,
  RESPONSE_CP_REPORTS,
  REQUEST_CP_REPORTS_FAILURE,
  REQUEST_TASK_TRIPS_REPORTS,
  RESPONSE_TASK_TRIPS_REPORTS,
  REQUEST_TASK_TRIPS_REPORTS_FAILURE,
  REQUEST_TASK_TRIP_REPORT,
  RESPONSE_TASK_TRIP_REPORT,
  REQUEST_TASK_TRIP_REPORT_FAILURE,
  REQUEST_TASK_TRIP_REPORT_DOWNLOAD,
  RESPONSE_TASK_TRIP_REPORT_DOWNLOAD,
  REQUEST_TASK_TRIP_REPORT_DOWNLOAD_FAILURE,
} from "../actions/logisticReportsActions";

import {
  REQUEST_LOGISTIC_TRIPS_GEO,
  RESPONSE_LOGISTIC_TRIPS_GEO,
  REQUEST_LOGISTIC_TRIPS_GEO_FAILURE,
} from "../actions/logisticTripsActions";

import { states } from "./queriesStates";
import getDates from "./../shared/services/date.service";

const getNextDate = () => {
  const date = new Date();

  return new Date(date.setDate(date.getDate() + 1));
};

const initialState = {
  dataState: states.NOT_REQUESTED,
  getControlPointsDataState: states.NOT_REQUESTED,
  getTaskTripsReportsDataState: states.NOT_REQUESTED,
  getTaskTripReportDataState: states.NOT_REQUESTED,
  taskTripsReportDownloadDataState: states.NOT_REQUESTED,
  reportRangeTime: {
    reportStartDate: getDates.getNullTimeDate(new Date()),
    reportEndDate: getDates.getNullTimeDate(getNextDate()),
    reportStartTime: getDates.getNullTimeDate(new Date()),
    reportEndTime: getDates.getNullTimeDate(new Date()),
  },
  searchTerm: null,
  controlPoints: [],
  taskTrips: [],
  taskTrip: null,
  errors: [],
};

const reportTimeReducer = (state = initialState, action) => {
  switch (action.type) {
    case READY_CHANGE_TIME_LOGISTIC_REPORT: {
      const { name, value } = action.payload;
      const reportRangeTime = Object.assign({}, state.reportRangeTime);

      typeof name === "object"
        ? name.map((item, index) => {
            reportRangeTime[item] = value[index];
            return null;
          })
        : (reportRangeTime[name] = value);

      return Object.assign({}, state, {
        dataState: states.READY,
        reportRangeTime: reportRangeTime,
      });
    }

    case CHANGE_SEARCH_TERM_LOGISIC_REPORT: {
      return Object.assign({}, state, {
        searchTerm: action.data,
      });
    }

    case RESET_TIME_LOGISTIC_REPORT:
      return Object.assign({}, state, initialState);

    case REQUEST_CP_REPORTS: {
      return Object.assign({}, state, {
        getControlPointsDataState: states.REQUEST,
        controlPoints: [],
      });
    }
    case RESPONSE_CP_REPORTS: {
      return Object.assign({}, state, {
        getControlPointsDataState: states.READY,
        controlPoints: action.data.controlPoints,
      });
    }
    case REQUEST_CP_REPORTS_FAILURE: {
      return Object.assign({}, state, {
        getControlPointsDataState: states.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_TASK_TRIPS_REPORTS: {
      return Object.assign({}, state, {
        getTaskTripsReportsDataState: states.REQUEST,
        taskTrips: [],
      });
    }
    case RESPONSE_TASK_TRIPS_REPORTS: {
      return Object.assign({}, state, {
        getTaskTripsReportsDataState: states.READY,
        taskTrips: action.data.taskTrips,
      });
    }
    case REQUEST_TASK_TRIPS_REPORTS_FAILURE: {
      return Object.assign({}, state, {
        getTaskTripsReportsDataState: states.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_TASK_TRIP_REPORT: {
      return Object.assign({}, state, {
        getTaskTripReportDataState: states.REQUEST,
        taskTrip: null,
      });
    }
    case RESPONSE_TASK_TRIP_REPORT: {
      return Object.assign({}, state, {
        getTaskTripReportDataState: states.READY,
        taskTrip: action.data,
      });
    }
    case REQUEST_TASK_TRIP_REPORT_FAILURE: {
      return Object.assign({}, state, {
        getTaskTripReportDataState: states.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_LOGISTIC_TRIPS_GEO: {
      return Object.assign({}, state, {
        taskTripsReportGeojsonDataState: states.REQUEST,
      });
    }

    case RESPONSE_LOGISTIC_TRIPS_GEO: {
      const taskTrip = state.taskTrip;
      if (taskTrip !== null) {
        taskTrip.geojsonData = action.data;
      }

      return Object.assign({}, state, {
        taskTripsReportGeojsonDataState: states.READY,
        taskTrip: taskTrip,
      });
    }

    case REQUEST_LOGISTIC_TRIPS_GEO_FAILURE: {
      return Object.assign({}, state, {
        taskTripsReportGeojsonDataState: states.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_TASK_TRIP_REPORT_DOWNLOAD: {
      return Object.assign({}, state, {
        taskTripsReportDownloadDataState: states.REQUEST,
      });
    }

    case RESPONSE_TASK_TRIP_REPORT_DOWNLOAD: {
      return Object.assign({}, state, {
        taskTripsReportDownloadDataState: states.READY,
      });
    }

    case REQUEST_TASK_TRIP_REPORT_DOWNLOAD_FAILURE: {
      return Object.assign({}, state, {
        taskTripsReportDownloadDataState: states.FAILURE,
        errors: action.errors,
      });
    }

    default:
      return state;
  }
};

export default reportTimeReducer;
